export default __webpack_public_path__ + "static/media/eceb3adfdbfe6ea4ceec5276e3702330.svg";